import { useOperatorTasks } from '@/entities/OperatorTask/model/store';
import type { OperatorTaskRelatedResponse } from '@/core/generated/api';
import { operatorTaskService } from '@/entities/OperatorTask/api/operatorTaskService';
import { AsyncSearchField } from '@/shared/ui/AsyncSearchField';

interface TaskOrderSearchFieldProps {
    name: string;
    value: OperatorTaskRelatedResponse | null;
    onChange: (value: OperatorTaskRelatedResponse | null) => void;
    onBlur?: () => void;
    label?: string;
    disabled?: boolean;
    isRequired?: boolean;
    error?: string;
}

/** Выбирает заказ по номеру */
export const TaskOrderSearchField = (
    { name, value, onChange, onBlur, label = 'Заказ', disabled, isRequired, error }: TaskOrderSearchFieldProps
) => {
    const options = useOperatorTasks((state) => state.options);

    return (
        <AsyncSearchField<string, OperatorTaskRelatedResponse>
            name={name}
            label={label}
            value={value?.id ?? null}
            initialOption={value?.id
                ? {
                    id: value.id,
                    name: value.label ?? 'Выбранный заказ',
                    data: value
                }
                : null
            }
            onChange={(_id, option) => onChange(option?.data ?? null)}
            onBlur={onBlur}
            loadOptions={async (query) => {
                const response = await operatorTaskService.orders(query);

                return (response.items ?? []).slice(0, 7)
                    .flatMap((item) => item.id && item.availability?.id === 'available'
                        ? [{
                            id: item.id,
                            name: item.label ?? item.id,
                            data: item
                        }]
                        : []);
            }}
            error={error}
            isRequired={isRequired}
            disabled={disabled}
            minSearchLength={options?.minLookupSearchLength ?? 0}
            cacheScope={`${options?.lookupDefaultTake}-${options?.lookupMaxTake}-${options?.minLookupSearchLength}`}
            scrollHeight="18rem"
            placeholder="Введите номер заказа"
        />
    );
};
